module.exports = __webpack_public_path__ + "assets/img/logo.99224503.png";